import request from '@/utils/request'
import { menuCache } from '@/utils/menuCache'

let pendingMenuPromise = null

export function loadMenusOnce(forceRefresh = false) {
  const cached = !forceRefresh ? menuCache.get() : null
  if (Array.isArray(cached) && cached.length > 0) {
    const normalized = ensureLocalLearningCourseMenu(cached)
    menuCache.save(normalized)
    return Promise.resolve(normalized)
  }

  if (pendingMenuPromise) {
    return pendingMenuPromise
  }

  pendingMenuPromise = request.get('/v1/user/menus')
    .then(res => {
      const data = Array.isArray(res) ? res : (res.data || [])
      const normalized = ensureLocalLearningCourseMenu(data)
      menuCache.save(normalized)
      return normalized
    })
    .finally(() => {
      pendingMenuPromise = null
    })

  return pendingMenuPromise
}

export function clearPendingMenus() {
  pendingMenuPromise = null
}

function ensureLocalLearningCourseMenu(menus) {
  if (!Array.isArray(menus)) return []

  const hasCourseMenu = containsPath(menus, '/learning/courses')
  if (hasCourseMenu) return menus

  const nextMenus = menus.map(item => ({ ...item }))
  let learningModule = nextMenus.find(item => item.name === 'module_learning' || item.path === 'learning' || item.display_name === '学习中心')

  if (!learningModule) {
    learningModule = {
      id: -9000,
      name: 'module_learning',
      display_name: '学习中心',
      type: 'module',
      path: 'learning',
      icon: 'el-icon-reading',
      sort_order: 20,
      children_tree: []
    }
    nextMenus.push(learningModule)
  }

  learningModule.children_tree = Array.isArray(learningModule.children_tree)
    ? learningModule.children_tree.slice()
    : []

  learningModule.children_tree.unshift({
    id: -9001,
    parent_id: learningModule.id,
    name: 'menu_courses',
    display_name: '课程管理',
    type: 'menu',
    path: '/learning/courses',
    component: 'learning/CourseList',
    icon: 'el-icon-reading',
    sort_order: 1,
    children_tree: []
  })

  return nextMenus
}

function containsPath(nodes, path) {
  return nodes.some(node => {
    if (node.path === path) return true
    return Array.isArray(node.children_tree) && containsPath(node.children_tree, path)
  })
}
